import React, { useState, useEffect } from "react";
import { array, func, bool, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import More from "../../atoms/More";
import CustomStoryCard9 from "../../molecules/CustomStoryCard9";
import DfpAd from "../../dfp-ad";
import { staticTexts } from "../../utils/Translate";

import "./stories2AdWithLoadMore.m.css";

const TransparentOverlay = () => {
  return <div styleName="transparent-overlay"></div>;
};

const Stories2AdWithLoadMore = ({
  list,
  onLoadMore = null,
  isMoreStories = false,
  loading = false,
  isBorderTop = false,
  isNotification = false,
  publisherAttributes,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [showButtonSpinner, setButtonSpinner] = useState(false);

  useEffect(() => {
    setIsMobile(global.deviceWidth < 876);
    setIsDesktop(global.deviceWidth > 1263);

    if (!loading) {
      setButtonSpinner(false);
    }
  }, [loading]);

  if (!(list && list.length)) {
    return null;
  }
  const storyList = [...list]; // Make a copy of it to avoid changing of list
  const firstSetStories = storyList.splice(0, 4); // Before Advertisement
  const remainingStories = storyList.splice(0, storyList.length); // After Advertisement

  const handleButtonClick = (e) => {
    setButtonSpinner(true);
    onLoadMore(e);
  };

  const MoreComponent = (
    <div styleName={`load-more-view ${publisherAttributes.lang === "en" ? "en-load-more-view" : ""}`}>
      <More
        type="load-more"
        text={staticTexts(publisherAttributes.lang).more}
        onClick={handleButtonClick}
        showButtonSpinner={showButtonSpinner}
      />
    </div>
  );

  return (
    <>
      {showButtonSpinner && <TransparentOverlay />}
      <div styleName="wrapper" className="two-stories-with-load-more-wrapper">
        {isDesktop && <div />}
        <div className="stories-set">
          {firstSetStories.map((story, index) => (
            <CustomStoryCard9
              story={story}
              key={index}
              className={`${isBorderTop && "border-line-top"}`}
              aspectRatio={isMobile ? [4, 3] : [3, 2]}
              imageType={isMobile ? "image4x3" : "image3x2"}
              isNotification={isNotification}
              publisherLang={publisherAttributes.lang}
              src="stories-2-ad-with-load-more"
              updatedFont={true}
              langClass={`${publisherAttributes.lang}-story-card`}
              widths={global.deviceWidth < 876 ? [150] : [200]}
            />
          ))}

          <div styleName="ad-wrapper">
            <div styleName="ad-slot">
              <DfpAd
                adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_336x280_R3" : "News_336x280_R3"}
                slotId="Stories2AdWithLoadMore-firstAd-1"
              />
            </div>
          </div>

          {remainingStories.length > 0 &&
            remainingStories.map((story, index) => (
              <div key={index}>
                {index !== 0 && index % 6 === 0 && (
                  <div styleName="ad-wrapper">
                    <div styleName="ad-slot">
                      <DfpAd
                        adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_336x280_R3" : "News_336x280_R3"}
                        slotId={`Stories2AdWithLoadMore-secondAd-${index / 6 + 1}`}
                      />
                    </div>
                  </div>
                )}
                <CustomStoryCard9
                  story={story}
                  aspectRatio={isMobile ? [4, 3] : [3, 2]}
                  imageType={isMobile ? "image4x3" : "image3x2"}
                  isNotification={isNotification}
                  publisherLang={publisherAttributes.lang}
                  src="stories-2-ad-with-load-more"
                  updatedFont={true}
                  langClass={`${publisherAttributes.lang}-story-card`}
                  widths={global.deviceWidth < 876 ? [150] : [200]}
                />
              </div>
            ))}

          {isMoreStories ? MoreComponent : null}
        </div>

        <div>
          <div styleName="side-ad" className="side-ad">
            <DfpAd
              adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_300x250_R2" : "News_336x280_R2"}
              slotId="Stories2AdWithLoadMore-sideAd"
            />
          </div>
        </div>
      </div>
    </>
  );
};

Stories2AdWithLoadMore.propTypes = {
  list: array,
  onLoadMore: func,
  setLoading: func,
  loading: bool,
  isMoreStories: bool,
  isBorderTop: bool,
  isNotification: bool,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(Stories2AdWithLoadMore);
